import { FormConfigurationModel } from './../../../../lib/ng2-sapmp/src/ui-components/form-builder/form-configuration.model';
import { Component, OnChanges, OnInit, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AuthenticationService } from 'lib/ng2-sapmp/src/providers';
import { CareComponentService } from '../shared';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components';
import { Router, ActivatedRoute } from '@angular/router';
import { BREADCRUMBS, ADDP_PERMISSION_MAPPING } from 'config';
import { PageLoaderService } from '../../../../lib/ng2-sapmp/src/ui-components/page-loader';
import { throwError } from 'rxjs';
import { CareModel } from '../shared';
import { MDMDetails } from 'app/models';

@Component({
  selector: 'app-search-fan',
  templateUrl: './search-fan.component.html',
  styleUrls: ['./search-fan.component.scss'],
  providers: [CareComponentService]
})

export class SearchFanComponent implements OnInit {
  public showErrors: boolean;
  public pageJson: any;
  public showData: boolean;
  public searchFanForm: FormGroup;
  private agentSingleFan: any;
  private fanId: number;
  public msg: any;
  public fanPattern = new RegExp("^[0-9]{8}$");
  public emailPattern = new RegExp("^[a-zA-Z0-9._%-]+@[a-zA-Z0-9._%-]+\.[a-zA-Z]{2,6}$");
  public disableSubmit = true;
  private agentProfileData: any;
  public isFanEmpty: boolean;
  public isEmailEmpty: boolean;
  public isFanInvalid: boolean;
  public isEmailInvalid: boolean;
  public fanErrorMessage: any;
  public emailErrorMessage: any;
  public fanInContext: any;
  public showEdit: boolean;
  public user: any;
  mdmDetails: MDMDetails;
  errorMessage: string;
  adminName;
  isUserAuthorized: boolean = true;
  isFirstNameEmpty: boolean = false;
  isLastNameEmpty: boolean = false;
  hideEmailFanFields: boolean = true;
  public namePattern = new RegExp("^[a-zA-Z0-9]{1,20}$");
  isFirstNameInvalid: boolean = false;
  isLastNameInvalid: boolean = false;
  disableSubmitForm: boolean = true;
  customerFan: any;
  customerEmail: any;

  constructor(private parentRouter: Router,
    private breadcrumb: BreadCrumbService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private pageloaderService: PageLoaderService,
    private route: ActivatedRoute, private utilityService: UtilityService, private careService: CareComponentService) {
    let profileInfo = JSON.parse(sessionStorage.getItem('profileAndPermsInfo'));
    let showPage = this.utilityService.checkPagePermission('admindashboard.lic', profileInfo.permissions.perm);
    if(showPage == false) {
      this.router.navigate(['restrictedUser']);
    }
    this.showErrors = false;
    this.careService = careService;
    this.mdmDetails = new MDMDetails();
    this.fanInContext = sessionStorage.getItem('fanInContext');
    if (this.fanPattern.test(this.fanInContext)) {
      this.showEdit = true;
    }
    else {
      this.showEdit = false;
      this.fanInContext = "";
    }
    let userJson = JSON.parse(sessionStorage.getItem('user'));
    if((userJson.user.firstName.length > 0 && userJson.user.firstName != 'NOT_FOUND') && (userJson.user.lastName.length > 0 && userJson.user.lastName != 'NOT_FOUND')) {
      this.adminName = userJson.user.firstName + " " + userJson.user.lastName;
    }
    else if((userJson.user.firstName.length > 0 && userJson.user.firstName != 'NOT_FOUND') && (userJson.user.lastName.length == 0 || userJson.user.lastName == 'NOT_FOUND')) {
      this.adminName = userJson.user.firstName;
    } 
    else if((userJson.user.firstName.length == 0 || userJson.user.firstName == 'NOT_FOUND') && (userJson.user.lastName.length > 0 && userJson.user.lastName != 'NOT_FOUND')) {
      this.adminName = userJson.user.lastName;
    }
    else {
      this.adminName = "Unknown";
    }
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.searchFanForm = new FormGroup({
      anyFan: new FormControl('', [<any>Validators.required, <any>Validators.pattern('[0-9]{1,10}')]),
      anyEmail: new FormControl('', [<any>Validators.required]),
      firstName: new FormControl('', [<any>Validators.required, <any>Validators.pattern('[a-zA-Z0-9]{1,20}')]),
      lastName: new FormControl('', [<any>Validators.required, <any>Validators.pattern('[a-zA-Z0-9]{1,20}')])
    });
    this.isFanEmpty = false;
    this.isEmailEmpty = false;
    this.isFanInvalid = false;
    this.isEmailInvalid = false;
    this.fanErrorMessage = "";
    this.emailErrorMessage = "";
    const breadcrumb = new BreadCrumbModel();
    breadcrumb.label = 'Select foundation account';
    breadcrumb.routerLink = 'care/searchFan';
    this.breadcrumb.setCurrentBreadCrumb(breadcrumb);

    this.pageloaderService.setPageLoaderStatus(false);
    // this.careService.doRequestCareService(this.utilityService.getEnvConfig().getSearchFanPageConfigUrl)
    //   .subscribe(respobj => {
    this.pageJson = this.route.snapshot.data.pageData.caresearchFan;
    this.pageloaderService.setPageLoaderStatus(true);
    this.showData = true;

    // this.searchFanForm = this.formBuilder.group({
    //   anyFan : this.searchFanForm.controls['anyFan']
    // });

    this.agentProfileData = this.careService.getCareModel();
    // }, error => {
    //   this.handleError(error);
    // });
  }

  displayEdit() {
    sessionStorage.removeItem("fanInContext");
    this.fanInContext = "";
    this.showEdit = false;
  }

  checkFan(event) {
    if (this.searchFanForm.value.anyFan == '') {
      this.isFanEmpty = true;
      this.isFanInvalid = false;
    }
    else if (!this.fanPattern.test(this.searchFanForm.value.anyFan)) {
      this.isFanEmpty = false;
      this.isFanInvalid = true;
    }
    else {
      this.isFanEmpty = false;
      this.isFanInvalid = false;
    }
  }

  checkEmail(event) {
    if (this.searchFanForm.value.anyEmail == '') {
      this.isEmailEmpty = true;
      this.isEmailInvalid = false;
    }
    else if (!this.emailPattern.test(this.searchFanForm.value.anyEmail)) {
      this.isEmailEmpty = false;
      this.isEmailInvalid = true;
    }
    else {
      this.isEmailEmpty = false;
      this.isEmailInvalid = false;
    }
  }

  checkName(nameType: string, event: any) {
    if (nameType === 'firstName') {
      if (this.searchFanForm.value.firstName == '') {
        this.isFirstNameEmpty = true;
      } else if (!this.namePattern.test(this.searchFanForm.value.firstName)) {
        this.isFirstNameEmpty = false;
        this.isFirstNameInvalid = true;
      } else {
        this.isFirstNameEmpty = false;
        this.isFirstNameInvalid = false;
      }
    }
    else if (nameType === 'lastName') {
      if (this.searchFanForm.value.lastName == '') {
        this.isLastNameEmpty = true;
      } else if (!this.namePattern.test(this.searchFanForm.value.lastName)) {
        this.isLastNameEmpty = false;
        this.isLastNameInvalid = true;
      } else {
        this.isLastNameEmpty = false;
        this.isLastNameInvalid = false;
      }
    }
  }


  ngDoCheck() {
    if (this.fanInContext && this.fanInContext.length === 8) {
      if (this.fanPattern.test(this.fanInContext) && this.emailPattern.test(this.searchFanForm.value.anyEmail)) {
        this.disableSubmit = false;
      }
      else {
        this.disableSubmit = true;
      }
    }
    else {
      if (this.fanPattern.test(this.searchFanForm.value.anyFan) && this.emailPattern.test(this.searchFanForm.value.anyEmail)) {
        this.disableSubmit = false;
      }
      else {
        this.disableSubmit = true;
      }
    }
  }


  handleError(error) {
    if (error) {
      if (error.status === 404) {
        this.errorMessage = "User profile is missing.";
      }
      else {
        this.errorMessage = "Something went wrong. Please try again later.";
      }
    }
    this.showErrors = true;
    return throwError(error);
  }

  validate(){
    this.pageloaderService.setPageLoaderStatus(false);
    if (this.disableSubmit === false) {
      // this.agentProfileData.agentUserId = this.fanInContext;
      // this.agentProfileData.customerEmail = this.searchFanForm.value.anyEmail;
      let fan;
      if (!this.showEdit) {
        fan = this.searchFanForm.value.anyFan;
      }
      else {
        fan = this.fanInContext;
      }
      let customerEmail = this.searchFanForm.value.anyEmail;
      let data = {
        customerEmail: customerEmail,
        fan: fan
      }

      this.customerFan = fan;
      this.customerEmail = customerEmail;
      
      this.careService.validateUserEmail(data).subscribe(resp_ => {
        this.pageloaderService.setPageLoaderStatus(true);
        //show error message if customer role is not authorized to device enrollment or not listed in MBIZ
        if(resp_.status == "NOT_MATCHED"){
            this.showErrors = true;
            this.isUserAuthorized = false;
            this.disableSubmit = true;
            this.errorMessage = resp_.message;
            this.hideEmailFanFields = false;
        }else{
            this.showErrors = false;
            this.isUserAuthorized = true;
            this.disableSubmit = false;
            this.hideEmailFanFields = true;
            let firstName = resp_.firstName;
            let lastName = resp_.lastName;
            localStorage.setItem('customerFirstName', firstName);
            localStorage.setItem('customerLastName', lastName);
            this.next();
        }
      }, error => {
          this.pageloaderService.setPageLoaderStatus(true); 
          this.handleError(error);
      });

    }
  }

  submitForm(){
      let firstName = this.searchFanForm.value.firstName;
      let lastName = this.searchFanForm.value.lastName;
      if(firstName == '' || lastName == ''){
        if(firstName == ''){
          this.isFirstNameEmpty = true;
        } 
        if(lastName == ''){
          this.isLastNameEmpty = true;
        }
      }else{
        localStorage.setItem('customerFirstName', firstName);
        localStorage.setItem('customerLastName', lastName);
        this.next();
      }
  }

  cancelForm(){
    this.searchFanForm.reset();
    this.isUserAuthorized = true;
    this.hideEmailFanFields = true;
    this.showErrors = false;
  }

  next() {
    this.pageloaderService.setPageLoaderStatus(false);
    if (this.disableSubmit === false) {
      // this.agentProfileData.agentUserId = this.fanInContext;
      // this.agentProfileData.customerEmail = this.searchFanForm.value.anyEmail;
      let fan;
      if (!this.showEdit) {
        fan = this.searchFanForm.value.anyFan;
      }
      else {
        fan = this.fanInContext;
      }
      let customerEmail = this.searchFanForm.value.anyEmail;
      // let url = '';
      // if (!this.utilityService.getEnvConfig().useMock) {
      //   url = this.utilityService.getEnvConfig().careSearchFanUrl + this.agentProfileData.searchFan;
      // }else {
      //   url = this.utilityService.getEnvConfig().careSearchFanUrlMock;
      // }
        let url = this.utilityService.getEnvConfig().updateProfile;
        this.careService.updateProfile(url, fan, customerEmail)
          .subscribe(respobj => {
            // this.agentProfileData.customerName = respobj.customerName;
            // this.agentProfileData.customerEmail = respobj.customerEmail;
            // this.agentProfileData.agentUserId = respobj.agentUserId;
            // this.agentProfileData.tcmAopEmailAddress = respobj.tcmAopEmailAddress;
            // this.agentProfileData.showEdit = true;
            // this.agentProfileData.selectedLaunchMode = '';
            // this.agentProfileData.showResetOption = '';
            // this.careService.setCareModel(this.agentProfileData);
            // this.authenticationService.setAuthToken('authToken', respobj.jwtToken);
            // sessionStorage.setItem('sapmp_jwtToken', respobj.jwtToken);

            this.authenticationService.getUserDetails()
              .subscribe(resp => {
                let profileAndPermsInfo = JSON.parse(sessionStorage.getItem('profileAndPermsInfo'));
                this.user = this.authenticationService.getProfileModel(profileAndPermsInfo.profile);
                if (this.user.addpAuthority != 'NONE') {
                  this.authenticationService.getFanSignedUpStatus()
                    .subscribe(resp => {
                      sessionStorage.setItem("accountSummaryData", JSON.stringify(resp));
                      sessionStorage.setItem('initialSignupStatus', resp.initialSignupStatus);
                      sessionStorage.setItem('noOfDevice', resp.noOfDevices);
                      if (!resp.efotaFansSummary) {
                        sessionStorage.setItem('efotaEnrolledFanList', '[]');
                      }
                      else {
                        let efotaFansSum = resp.efotaFansSummary;
                        let efotaEnrolledFanList = [];
                        for (let i = 0; i < efotaFansSum.length; i++) {
                          if (efotaFansSum[i].status == "ACTIVE") {
                            for (let j = 0; j < efotaFansSum[i].count; j++) {
                              efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                            }
                          }
                        }
                        sessionStorage.setItem('efotaEnrolledFanList', JSON.stringify(efotaEnrolledFanList));
                      }
                      if (!resp.efotaNotEnrolledFanList) {
                        sessionStorage.setItem('efotaNotEnrolledFanList', '[]');
                        sessionStorage.setItem('efotaEnrollmentInfo', '[]');
                      }
                      else {
                        sessionStorage.setItem('efotaEnrollmentInfo', JSON.stringify(resp.efotaEnrollmentInfo));
                        sessionStorage.setItem('efotaNotEnrolledFanList', JSON.stringify(resp.efotaNotEnrolledFanList));
                      }

                      if (resp.allFansInEligible === true) {
                        this.user.fanSignedUpStatus = 'NotEligible';
                        // if(resp.noOfFans == 0 && resp.noOfDevices == 0 ){
                        //   this.user.fanSignedUpStatus = 'Unknown';
                        // }
                      } else {
                        if (resp.fansSummary.length > 0) {
                          let signupFanSum = resp.fansSummary;
                          let signupFanList = [];
                          let processingFanList = [];
                          for (let i = 0; i < signupFanSum.length; i++) {
                            if (signupFanSum[i].status == "AWAITING_SIGNUP") {
                              for (let j = 0; j < signupFanSum[i].count; j++) {
                                signupFanList.push(signupFanSum[i].fans[j]);
                              }
                            }
                          }
                          sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));
                          //for 'processing' fans
                          for (let i = 0; i < signupFanSum.length; i++) {
                            if (signupFanSum[i].status == "PROCESSING") {
                              for (let j = 0; j < signupFanSum[i].count; j++) {
                                //processingFanList.push(signupFanSum[i].fans[j]);
                                //getting fan info of 'processing' fan to store in session storage
                                for (let k = 0; k < resp.fanInfoList.length; k++) {
                                  if (signupFanSum[i].fans[j] === resp.fanInfoList[k].fan) {
                                    processingFanList.push(resp.fanInfoList[k]);
                                  }
                                }
                              }
                            }
                          }
                          sessionStorage.setItem('processingFanList', JSON.stringify(processingFanList));
                        }
                        if (this.user) {
                          this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
                        }
                        if (resp.productCode !== null && resp.productCode !== undefined) {
                          this.mdmDetails.productCode = resp.productCode;
                          this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
                          if (this.mdmDetails.productCode === 'ADDPMDM') {
                            this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                            let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                            productDetails.emmProductCode = 'ADDPMDM';
                            productDetails.selectedAccID = resp.ibmEmmAccountId;
                            productDetails.signupEmmStatus = 'revised';
                            sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
                          } else {
                            if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                              this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                            }
                            if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                              this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                            }
                            if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                              sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                            }
                          }
                          sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
                        }
                      }
                      this.authenticationService.setUser(this.user);
                      sessionStorage.setItem('permissions', JSON.stringify(profileAndPermsInfo.permissions));
                      const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
                      const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                      if (redirectInfo) {
                        this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                      }
                      this.pageloaderService.setPageLoaderStatus(true);
                      this.router.navigate(['dashboard']);
                    }, error => {
                      this.user.fanSignedUpStatus = 'Error';
                      this.authenticationService.setUser(this.user);
                      sessionStorage.setItem('permissions', JSON.stringify(profileAndPermsInfo.permissions));
                      const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
                      const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                      if (redirectInfo) {
                            this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                      }
                    this.pageloaderService.setPageLoaderStatus(true);
                    this.router.navigate(['dashboard']);
                    });
                }
                else {
                  this.authenticationService.setUser(this.user);
                    const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
                          const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];
                          if (redirectInfo) {
                                this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
                          }
                    sessionStorage.setItem('permissions', JSON.stringify(profileAndPermsInfo.permissions));
                    // this.loginSuccessRedirect();
                  this.pageloaderService.setPageLoaderStatus(true);
                  this.router.navigate(['dashboard']);
                }

                // sessionStorage.setItem('sapmp_jwtToken', resp.jwtToken);
                // this.router.navigate(['dashboard']);
              }, error => {
                this.pageloaderService.setPageLoaderStatus(true);
                this.handleError(error);
              });
            // this.router.navigate(['dashboardTitle'], { relativeTo: this.route.parent });
          }, error => {
            // this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
            this.pageloaderService.setPageLoaderStatus(true);
            this.handleError(error);
          });

        

    }
  }

  getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'AWAITING_SIGNUP'; }).length;
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

  continue(){
    this.showErrors = false;
    this.next();
  }
}
